import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaArrowLeft, FaGlobe } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
`;

const LanguageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const LanguageOption = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  background-color: ${props => props.isSelected ? 'var(--primary-color-light)' : 'var(--bg-secondary)'};
  border: 1px solid ${props => props.isSelected ? 'var(--primary-color)' : 'var(--border-color)'};
  border-radius: 10px;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: var(--primary-color-light);
    border-color: var(--primary-color);
  }

  svg {
    font-size: 24px;
  }
`;

const Language: React.FC = () => {
  const navigate = useNavigate();
  const { t, currentLanguage, setLanguage } = useLanguage();

  const languages = [
    {
      id: 'fr',
      name: t('language.french'),
      nativeName: 'Français'
    },
    {
      id: 'en',
      name: t('language.english'),
      nativeName: 'English'
    }
  ];

  const handleLanguageChange = (language: string) => {
    setLanguage(language as 'fr' | 'nl' | 'en');
    navigate('/profile');
  };

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Title>{t('language.title')}</Title>

      <LanguageList>
        {languages.map(language => (
          <LanguageOption
            key={language.id}
            isSelected={currentLanguage === language.id}
            onClick={() => handleLanguageChange(language.id)}
          >
            <FaGlobe />
            <div>
              <div>{language.name}</div>
              <div style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                {language.nativeName}
              </div>
            </div>
          </LanguageOption>
        ))}
      </LanguageList>
    </Container>
  );
};

export default Language; 